
import { Injectable } from '@angular/core';
import { Platform, AlertController, ToastController } from 'ionic-angular';
import { Geolocation } from '@ionic-native/geolocation';
import { Device } from '@ionic-native/device';
import { FileOpener } from '@ionic-native/file-opener';
import { File } from '@ionic-native/file';
import * as moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';

@Injectable()
export class GlobalServiceProvider {

    static isDevelopment: Boolean = false;
    static isTest: Boolean = true;
    static socketURL = GlobalServiceProvider.isTest ? 'https://bss.boothtransport.com:5001' : 'https://bss.boothtransport.com:5001/prod';;
    appConfig: any = {
        appErrorPrefix: '[TMS Error] ', //Configure the exceptionHandler decorator
        appTitle: 'BT Customer',
        version: 'v4.2.2',
        env: 'test',
        local: {
            appHost: 'http://localhost:8100',
            host: 'http://localhost:8191',
            apiUrl: '/tms/api'
        },
        dev: {
            appHost: 'http://tmsdev.boothtransport.com',
            host: 'http://tmsapidev.boothtransport.com',
            apiUrl: '/tms/api',
        },
        test: {
            appHost: 'http://tmstest.boothtransport.com',
            host: 'https://tmsapitest.boothtransport.com',
            apiUrl: '/tms/api',
        },
        production: {
            appHost: 'http://tms.boothtransport.com',
            host: 'https://tmsapi.boothtransport.com',
            apiUrl: '/tms/api'
        },
        AUST_STATES: ['NSW', 'VIC', 'SA', 'WA', 'QLD', 'TAS', 'NT'],
        DEPOTS: ['VILLAWOOD', 'LAVERTON', 'WINGFIELD', 'PERTH', 'ROCKLEA'],
        FLEETS: ['FaW', 'TaBS', 'CoMS', 'GeMS'],
        BaseApiUrl: GlobalServiceProvider.isTest ? "https://bss.boothtransport.com:5001/btcustomer" : "https://bss.boothtransport.com:5001/prod/btcustomer",
        BaseApiTmsUrl: GlobalServiceProvider.isTest ? 'https://bss.boothtransport.com:5001/bss/api' : 'https://bss.boothtransport.com:5001/prod/bss/api',
        ixomApiUrl: GlobalServiceProvider.isTest ? 'https://bss.boothtransport.com:5001' : 'https://bss.boothtransport.com:5001/prod',
        bss_api: GlobalServiceProvider.isTest ? 'https://bss.boothtransport.com:5001/bss/api' : 'https://bss.boothtransport.com:5001/prod/bss/api',
        linkUrlDashbord: GlobalServiceProvider.isTest ? 'https://bss.boothtransport.com:3705/pages/dashboard/' : 'https://bss.boothtransport.com:3706/pages/dashboard/',
        // linkUrlDashbord: GlobalServiceProvider.isTest ? 'http://localhost:4200/pages/dashboard/' : 'https://bss.boothtransport.com:3706/pages/dashboard/',
        // ixomApiUrl: 'http://localhost:9084',
        keyPass: 'YWRtaW5fcXBoYW06cXRwPjIwMTE=',
        mtdapiUrl: 'http://mtdapi.boothtransport.com/tms/api/mtdata',
        tokenBTCustomerAPI: 'tokenBTCustomerAPI',
        tokenTMSAPI: 'tokenTMSAPI',
        googleMapApiKey: 'AIzaSyARWSvSVv6zl4TDIWmrDpEbVXl0JVJH9qQ',//get from BTcustomer
        iconUrlMarker: 'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=',
        red: '|FE4646|000000',
        yellow: '|ffff00|000000',
        green: '|00ff00|000000',
    };

    constructor(
        public plt: Platform,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        public geolocation: Geolocation,
        private device: Device,
        public platform: Platform,
        private file: File,
        private fileOpener: FileOpener,
        private transfer: FileTransfer

    ) {
        console.log('Hello GlobalServiceProvider Provider');
    }

    private loginUserData: any = null;
    get getLoginUserData(): any {
        return this.loginUserData;
    }
    set setLoginUserData(valueObj: any) {
        this.loginUserData = valueObj;
    }

    checkdevice() {
        if (this.plt.is('ios') || this.plt.is('android') || this.plt.is('windows')) {
            return true;
        } else {
            return false;
        }
    }

    message(title: string, content: string) {
        let alert = this.alertCtrl.create({
            title: title,
            subTitle: content,
            buttons: ['OK']
        });
        alert.present();
    }

    messageToast(content: string, position: string, duration: number) {
        let toast = this.toastCtrl.create({
            message: content,
            duration: duration,
            position: position,
            cssClass: 'toastContainerCss'
        });
        toast.present();
    }

    capitalizeFirstLetter(str) {
        if (str) {
            var pieces = str.split(" ");
            for (var i = 0; i < pieces.length; i++) {
                var j = pieces[i].charAt(0).toUpperCase();
                pieces[i] = j + pieces[i].substr(1).toLowerCase();
            }
            return pieces.join(" ");
        } else {
            return '';
        }
    }

    SET_PAGE_LOGIN() {
        if (this.checkdevice()) {
            return 'LoginPage';
        } else {
            return 'LoginWebPage';
        }
    }
    getCurrentPosition() {
        return this.geolocation.getCurrentPosition().then(pos => {
            // console.log('pos:', pos);
            return {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude
            };
        });
    }

    isIphone() {
        if (this.platform.is('cordova')) {
            if (this.platform.is('ios')) {
                if (this.device.model.startsWith('iPhone10')) {
                    return 'iPhone10';
                } else {
                    return 'ios';
                }
            }
        } else {
            return false;
        }
    }
    arrayToCSV(filename, filePath, arrayData, headers) {
        const promise = new Promise((resolve, reject) => {
            var csv = headers.toString() + '\n' + this.ConvertToCSV(arrayData);
            this.file.writeFile(filePath, filename, csv, { replace: true })
                .then(fileEntry => {
                    this.fileOpener.open(
                        filePath + filename,
                        'text/csv'
                    );
                    resolve('OK');
                }, error => {
                    reject(error);
                });
        });
        return promise;
    }

    isIphoneX() {
        if (this.platform.is('cordova')) {
            console.log('device:', this.device.model);
            return this.device.model.startsWith('iPhone10');
        }else{
           
            return false;
        }
    }        
    ConvertToCSV(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = '';
        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line != '') line += ','

                line += array[i][index];
            }

            str += line + '\n';
        }
        return str;
    }

    jsonDatetimeToString(jsonDate) {
        try {
            if (jsonDate != null) {
                var stringArray = jsonDate.split('T');
                // console.log('stringArray: ', stringArray)
                if (stringArray.length > 1) {
                    var dateObjectArray = stringArray[0].split('-');
                    var timeObjectArray = stringArray[1].split(':');
                    return dateObjectArray[2] + '/' + dateObjectArray[1] + '/' + dateObjectArray[0] + ' ' + timeObjectArray[0] + ':' + timeObjectArray[1];
                } else {
                    if(stringArray.length === 1){
                        return moment(jsonDate).format('DD/MM/YYYY HH:mm');
                    }else{
                        return jsonDate;
                    }
                }
            }
        } catch (ex) {
        }
    }
    
    getCurrentPlace(lat, lng) {
        // console.log('getCurrentPlace:', lat, '_', lng);
        let geocoder = new google.maps.Geocoder;
        let latlng = {
            lat: lat,
            lng: lng
        };
        return new Promise((resolve, reject) => {
            geocoder.geocode({ 'location': latlng }, (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
                if (status.toString() === 'OK') {
                    console.log('results:', results);
                    let object = {};
                    if (results[0]) {
                        object = {
                            fullAddress: results[0].formatted_address ? results[0].formatted_address : '',
                            address: results[0].address_components[0].long_name ? results[0].address_components[0].long_name + ' ' + results[0].address_components[1].long_name : '',
                            suburb: results[0].address_components[2].long_name ? results[0].address_components[2].long_name : '',
                            // postcode: results[0].address_components[6].long_name ? results[0].address_components[6].long_name : '',
                            // state: results[0].address_components[4].short_name ? results[0].address_components[4].short_name : ''
                            postcode: results[0].address_components[6] ? results[0].address_components[6].long_name ? results[0].address_components[6].long_name : '' : '',
                            state: results[0].address_components[4] ? results[0].address_components[4].short_name ? results[0].address_components[4].short_name : '' : ''
                        }
                        resolve(object);
                    } else {
                        reject('Unable to reverse geocode');
                    }
                } else {
                    reject('Geocoder failed due to ' + status.toString());
                }
            });
        });
    }

    getPositionByAddress(address) {
        console.log('getPositionByAddress:', address);
        let geocoder = new google.maps.Geocoder;
        return new Promise((resolve, reject) => {
            geocoder.geocode({ 'address': address }, (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    resolve(results[0].geometry.location);
                }
                else {
                    reject(status);
                }

            });
        });
    }

    maxDateTime() {
        return moment().add(5, 'y').format('YYYY-MM-DD');
    }

    createPdf(docDefinition) {
        return new Promise((resolve, reject) => {
          const pdf = pdfMake.createPdf(docDefinition);
          pdf.getBase64(output => {
            resolve(this.base64ToUint8Array(output));
          });
        });
      }

      base64ToUint8Array(base64) {
        console.log('convert base64 to Uint8Array');
        const raw = atob(base64);
        const uint8Array = new Uint8Array(raw.length);
        for (let i = 0; i < raw.length; i++) {
          uint8Array[i] = raw.charCodeAt(i);
        }
        return uint8Array;
      }

    async downloadFilesURL(url: any, filename: string) {
        let pathFile = null;
        let token = localStorage.getItem('tokenBTCustomerAPI');
        let options = {
            headers: {
                "Authorization": "Bearer " + token
            }
        };
        if (this.platform.is('ios')) {
            pathFile = this.file.cacheDirectory;
        } else {
            pathFile = this.file.externalApplicationStorageDirectory + 'cache/';
        }

        return new Promise((resolve: any, reject: any) => {
            this.platform.ready().then(() => {
                console.log('0000')
                const fileTransfer: FileTransferObject = this.transfer.create();
                if (fileTransfer) {
                    fileTransfer.download(url, pathFile + filename, false, options).then((entry: any) => {
                        console.log('download complete: ' + entry.toURL());
                        resolve(entry.toURL());
                    }, (error: any) => {
                        resolve(null);
                    }).catch(() => {
                        resolve(null);
                    });
                } else {
                    resolve(null);
                }
            });
        });
    }

    isIxom(): boolean {
        let ixomCustomer = false;
        if (this.getLoginUserData && ((this.getLoginUserData.CustCode &&
            this.getLoginUserData.CustCode.indexOf('IXO') > -1) || (this.getLoginUserData.isIxomGroup && this.getLoginUserData.isIxomGroup === true))) {
            ixomCustomer = true;
        }
        return ixomCustomer;
    }
}




// WEBPACK FOOTER //
// ./src/providers/global-service/global-service.ts